(() => {
  const selector = '[data-vp-buy-now]';

  const bind = (root) => {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll(selector).forEach((button) => {
      if (button.dataset.vpBuyNowBound === 'true') return;
      button.dataset.vpBuyNowBound = 'true';
      button.addEventListener('click', onBuyNow);
    });
  };

  const onBuyNow = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const button = event.currentTarget;
    const form = button.closest('form');
    if (!form || button.hasAttribute('disabled')) return;

    const addUrl = window.theme?.routes?.cart_add_url || '/cart/add.js';
    const formData = new FormData(form);

    button.setAttribute('disabled', 'disabled');

    fetch(addUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    })
      .then((response) => {
        if (!response.ok) throw new Error('cart add failed');
        window.location.href = '/checkout';
      })
      .catch(() => {
        button.removeAttribute('disabled');
      });
  };

  const init = () => bind(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();
